import { Factory } from '../../services/Factory';

namespace app.controllers.project {

    //import AccountService = app.services.account;

  interface IDeleteControllerScope extends angular.IScope {
        project;
        closeModal: Function;
        startDelete: Function;
        saving: boolean;
        authyToken: string;
    }

    export class ProjectDeleteModalController {
        private $scope:IDeleteControllerScope;
        private $modalInstance;
        private $location;
        private project;
        private projectService: app.services.project.ProjectService;
        private accountService: app.services.account.AccountService;
        private notificationService: app.services.INotificationService;

        constructor($scope:IDeleteControllerScope, $modalInstance, $location, project, projectService: app.services.project.ProjectService, accountService: app.services.account.AccountService, notificationService: app.services.INotificationService) {
            this.$scope = $scope;
            this.$modalInstance = $modalInstance;
            this.$location = $location;
            this.project = project;
            this.accountService = accountService;
            this.projectService = projectService;
            this.notificationService = notificationService;

            this.$scope.closeModal = () => {
                this.$modalInstance.close();
            };

            this.$scope.startDelete = () => {
                this.$scope.saving = true;

                projectService.Delete(this.project, this.$scope.authyToken, () => {
                    this.$scope.saving = false;
                    this.$modalInstance.close();

                    this.notificationService.addSuccess({
                        title: "Project deleted successfully",
                        description: this.project.name,
                        timeout: 5000
                    });

                    $location.path('/project');

                }, (data) => {
                    this.$scope.saving = false;
                    this.notificationService.addError({
                        title: "Unable to delete project",
                        description: data,
                        timeout: 5000
                    });
                })

            };

            this.accountService.StartMFA();
        }
    }

    frontendApp.controller("ProjectDeleteModalController", ["$scope", "$uibModalInstance", "$location", "project", "ProjectService", "AccountService", "NotificationService", Factory.Create(ProjectDeleteModalController)]);
}